var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { sdsCustomElement } from '../../../utilities/custom-components';
import { translate } from '../../../utilities/translate';
import { SdsGalleryItemBase } from '../_sds-gallery-item-base';
import { PinchZoomHandler } from './pinch-zoom/pinch-zoom-handler';
import styles from './sds-gallery-image.lit.scss';
const supportedImageMimeTypes = [
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/png',
    'image/svg+xml',
    'image/bmp',
];
/**
 *  Gallery Image component that renders given content.
 *
 *  @slot The slot showing of the image content
 *
 *  @tag sds-gallery-image
 */
let SdsGalleryImage = (() => {
    var _SdsGalleryImage_contentType_accessor_storage, _SdsGalleryImage__sdsGalleryImage_accessor_storage, _SdsGalleryImage__sdsGalleryImageWrapper_accessor_storage, _SdsGalleryImage__sdsGalleryImageZoomOut_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-gallery-image')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsGalleryItemBase;
    let _contentType_decorators;
    let _contentType_initializers = [];
    let _contentType_extraInitializers = [];
    let __sdsGalleryImage_decorators;
    let __sdsGalleryImage_initializers = [];
    let __sdsGalleryImage_extraInitializers = [];
    let __sdsGalleryImageWrapper_decorators;
    let __sdsGalleryImageWrapper_initializers = [];
    let __sdsGalleryImageWrapper_extraInitializers = [];
    let __sdsGalleryImageZoomOut_decorators;
    let __sdsGalleryImageZoomOut_initializers = [];
    let __sdsGalleryImageZoomOut_extraInitializers = [];
    var SdsGalleryImage = _classThis = class extends _classSuper {
        /**
         * Item content type
         * @attr
         */
        get contentType() { return __classPrivateFieldGet(this, _SdsGalleryImage_contentType_accessor_storage, "f"); }
        set contentType(value) { __classPrivateFieldSet(this, _SdsGalleryImage_contentType_accessor_storage, value, "f"); }
        get _sdsGalleryImage() { return __classPrivateFieldGet(this, _SdsGalleryImage__sdsGalleryImage_accessor_storage, "f"); }
        set _sdsGalleryImage(value) { __classPrivateFieldSet(this, _SdsGalleryImage__sdsGalleryImage_accessor_storage, value, "f"); }
        get _sdsGalleryImageWrapper() { return __classPrivateFieldGet(this, _SdsGalleryImage__sdsGalleryImageWrapper_accessor_storage, "f"); }
        set _sdsGalleryImageWrapper(value) { __classPrivateFieldSet(this, _SdsGalleryImage__sdsGalleryImageWrapper_accessor_storage, value, "f"); }
        get _sdsGalleryImageZoomOut() { return __classPrivateFieldGet(this, _SdsGalleryImage__sdsGalleryImageZoomOut_accessor_storage, "f"); }
        set _sdsGalleryImageZoomOut(value) { __classPrivateFieldSet(this, _SdsGalleryImage__sdsGalleryImageZoomOut_accessor_storage, value, "f"); }
        constructor() {
            super();
            _SdsGalleryImage_contentType_accessor_storage.set(this, __runInitializers(this, _contentType_initializers, ''));
            _SdsGalleryImage__sdsGalleryImage_accessor_storage.set(this, (__runInitializers(this, _contentType_extraInitializers), __runInitializers(this, __sdsGalleryImage_initializers, void 0)));
            _SdsGalleryImage__sdsGalleryImageWrapper_accessor_storage.set(this, (__runInitializers(this, __sdsGalleryImage_extraInitializers), __runInitializers(this, __sdsGalleryImageWrapper_initializers, void 0)));
            _SdsGalleryImage__sdsGalleryImageZoomOut_accessor_storage.set(this, (__runInitializers(this, __sdsGalleryImageWrapper_extraInitializers), __runInitializers(this, __sdsGalleryImageZoomOut_initializers, void 0)));
            this._pinchZoom = __runInitializers(this, __sdsGalleryImageZoomOut_extraInitializers);
        }
        render() {
            return html ` ${this.getTemplate()} `;
        }
        firstUpdated() {
            if (this.isMainMode) {
                this._pinchZoom = PinchZoomHandler.create(this._sdsGalleryImage, this._sdsGalleryImageWrapper);
                this.updateZoomOutStyles();
                this.initZoomListener();
            }
        }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            var _a;
            (_a = this._pinchZoom) === null || _a === void 0 ? void 0 : _a.destroy();
            super.disconnectedCallback();
        }
        getTemplate() {
            if (this.propertiesIsInvalid) {
                return html `
                <sds-empty data-card-content="">
                    <div slot="title">${translate('sds.gallery.item.properties.incomplete')}</div>
                </sds-empty>
            `;
            }
            if (this.isMainMode) {
                return html `
                <div
                    id="sdsGalleryImageWrapper"
                    class="sds-gallery-item-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-full-screen-item-wrapper'
                    : ''}"
                >
                    <div
                        class="sds-gallery-actions-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-actions-wrapper-full'
                    : 'sds-gallery-actions-wrapper-default'}"
                    >
                        <span
                            id="sdsGalleryImageZoomOut"
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => { var _a; return (_a = this._pinchZoom) === null || _a === void 0 ? void 0 : _a.zoomOut(); }}"
                        >
                            <sds-icon size="16" name="zoom_out"></sds-icon>
                        </span>
                        <span
                            id="sdsGalleryImageZoomIn"
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => { var _a; return (_a = this._pinchZoom) === null || _a === void 0 ? void 0 : _a.zoomIn(); }}"
                        >
                            <sds-icon size="16" name="zoom_in"></sds-icon>
                        </span>
                        <span
                            id="sdsGalleryDownload"
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => this.toDownloadContent()}"
                        >
                            <sds-icon size="16" name="download"></sds-icon>
                        </span>
                        <span
                            id="sdsGalleryFullScreenToggle"
                            class="sds-gallery-action-wrapper ${this.isInFullScreen
                    ? 'sds-gallery-sub-action-wrapper-full'
                    : 'sds-gallery-sub-action-wrapper-default'}"
                            @click="${() => this.dispatchFullScreenEvent()}"
                        >
                            <sds-icon
                                size="16"
                                name="${this.isInFullScreen
                    ? 'exit_full_screen'
                    : 'go_full_screen'}"
                            ></sds-icon>
                        </span>
                    </div>

                    <img
                        id="sdsGalleryImage"
                        class="sds-gallery-main-image"
                        src="${this.correspondingUrl}"
                        alt="img"
                        @load="${() => {
                    var _a, _b;
                    (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`loadingSpinner${this.identifier}`)) === null || _b === void 0 ? void 0 : _b.remove();
                    if (this._sdsGalleryImage.offsetWidth >
                        this._sdsGalleryImage.offsetHeight) {
                        this._sdsGalleryImage.style.height = `${this.offsetHeight}px`;
                    }
                    else {
                        this._sdsGalleryImage.style.width = `${this.offsetWidth}px`;
                    }
                }}"
                    />

                    <div id="loadingSpinner${this.identifier}" class="sds-gallery-spinner">
                        <sds-loader color="white" size="lg"></sds-loader>
                    </div>
                </div>
            `;
            }
            return html `
            <div class="sds-gallery-item-wrapper">
                <img
                    id="sdsGalleryThumbImage${this.identifier}"
                    src="${this.correspondingUrl}"
                    alt="img"
                    @load="${() => {
                var _a, _b;
                this.updateImageSize();
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`loadingSpinner${this.identifier}`)) === null || _b === void 0 ? void 0 : _b.remove();
            }}"
                />

                <div id="loadingSpinner${this.identifier}" class="sds-gallery-spinner">
                    <sds-loader color="white" size="lg"></sds-loader>
                </div>
            </div>
        `;
        }
        initZoomListener() {
            var _a;
            (_a = this._pinchZoom) === null || _a === void 0 ? void 0 : _a.zoomChange.subscribe(() => {
                this.updateZoomOutStyles();
            });
        }
        updateZoomOutStyles() {
            var _a, _b;
            if (((_a = this._pinchZoom) === null || _a === void 0 ? void 0 : _a.scale) === ((_b = this._pinchZoom) === null || _b === void 0 ? void 0 : _b.minScale)) {
                this._sdsGalleryImageZoomOut.classList.add('sds-gallery-zoom-out-disable');
            }
            else {
                this._sdsGalleryImageZoomOut.classList.remove('sds-gallery-zoom-out-disable');
            }
        }
        updateImageSize() {
            var _a;
            const imageEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`sdsGalleryThumbImage${this.identifier}`);
            if (imageEl) {
                this.adjustItemSize.call(imageEl);
            }
        }
    };
    _SdsGalleryImage_contentType_accessor_storage = new WeakMap();
    _SdsGalleryImage__sdsGalleryImage_accessor_storage = new WeakMap();
    _SdsGalleryImage__sdsGalleryImageWrapper_accessor_storage = new WeakMap();
    _SdsGalleryImage__sdsGalleryImageZoomOut_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsGalleryImage");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _contentType_decorators = [property({
                type: String,
                attribute: 'content-type',
                reflect: true,
                hasChanged: (newVal) => {
                    if (!supportedImageMimeTypes.includes(newVal)) {
                        console.warn(`Unexpected Content Mime Type ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        __sdsGalleryImage_decorators = [query('#sdsGalleryImage')];
        __sdsGalleryImageWrapper_decorators = [query('#sdsGalleryImageWrapper')];
        __sdsGalleryImageZoomOut_decorators = [query('#sdsGalleryImageZoomOut')];
        __esDecorate(_classThis, null, _contentType_decorators, { kind: "accessor", name: "contentType", static: false, private: false, access: { has: obj => "contentType" in obj, get: obj => obj.contentType, set: (obj, value) => { obj.contentType = value; } }, metadata: _metadata }, _contentType_initializers, _contentType_extraInitializers);
        __esDecorate(_classThis, null, __sdsGalleryImage_decorators, { kind: "accessor", name: "_sdsGalleryImage", static: false, private: false, access: { has: obj => "_sdsGalleryImage" in obj, get: obj => obj._sdsGalleryImage, set: (obj, value) => { obj._sdsGalleryImage = value; } }, metadata: _metadata }, __sdsGalleryImage_initializers, __sdsGalleryImage_extraInitializers);
        __esDecorate(_classThis, null, __sdsGalleryImageWrapper_decorators, { kind: "accessor", name: "_sdsGalleryImageWrapper", static: false, private: false, access: { has: obj => "_sdsGalleryImageWrapper" in obj, get: obj => obj._sdsGalleryImageWrapper, set: (obj, value) => { obj._sdsGalleryImageWrapper = value; } }, metadata: _metadata }, __sdsGalleryImageWrapper_initializers, __sdsGalleryImageWrapper_extraInitializers);
        __esDecorate(_classThis, null, __sdsGalleryImageZoomOut_decorators, { kind: "accessor", name: "_sdsGalleryImageZoomOut", static: false, private: false, access: { has: obj => "_sdsGalleryImageZoomOut" in obj, get: obj => obj._sdsGalleryImageZoomOut, set: (obj, value) => { obj._sdsGalleryImageZoomOut = value; } }, metadata: _metadata }, __sdsGalleryImageZoomOut_initializers, __sdsGalleryImageZoomOut_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsGalleryImage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsGalleryImage = _classThis;
})();
export { SdsGalleryImage };
